export default "__VITE_ASSET__CJddHv0b__"